'use strict';

/////////////////////////////////////////////////
/////////////////////////////////////////////////
// BANKIST APP

/////////////////////////////////////////////////
// Data
// DIFFERENT DATA! Contains movement dates, currency and locale

const account1 = {
  owner: 'Jonas Schmedtmann',
  movements: [200, 455.23, -306.5, 25000, -642.21, -133.9, 79.97, 1300],
  interestRate: 1.2, // %
  pin: 1111,

  movementsDates: [
    '2019-11-18T21:31:17.178Z',
    '2019-12-23T07:42:02.383Z',
    '2020-01-28T09:15:04.904Z',
    '2020-04-01T10:17:24.185Z',
    '2020-05-08T14:11:59.604Z',
    '2022-02-24T17:01:17.194Z',
    '2022-02-26T23:36:17.929Z',
    '2022-03-01T10:51:36.790Z',
  ],
  currency: 'EUR',
  locale: 'pt-PT', // de-DE
};
let timerFun;
let CurAcc = account1;
const account2 = {
  owner: 'Jessica Davis',
  movements: [5000, 3400, -150, -790, -3210, -1000, 8500, -30],
  interestRate: 1.5,
  pin: 2222,

  movementsDates: [
    '2019-11-01T13:15:33.035Z',
    '2019-11-30T09:48:16.867Z',
    '2019-12-25T06:04:23.907Z',
    '2020-01-25T14:18:46.235Z',
    '2020-02-05T16:33:06.386Z',
    '2020-04-10T14:43:26.374Z',
    '2020-06-25T18:49:59.371Z',
    '2020-07-26T12:01:20.894Z',
  ],
  currency: 'USD',
  locale: 'en-US',
};

const accounts = [account1, account2];

/////////////////////////////////////////////////
// Elements
const labelWelcome = document.querySelector('.welcome');
const labelDate = document.querySelector('.date');
const labelBalance = document.querySelector('.balance__value');
const labelSumIn = document.querySelector('.summary__value--in');
const labelSumOut = document.querySelector('.summary__value--out');
const labelSumInterest = document.querySelector('.summary__value--interest');
const labelTimer = document.querySelector('.timer');

const containerApp = document.querySelector('.app');
const containerMovements = document.querySelector('.movements');

const btnLogin = document.querySelector('.login__btn');
const btnTransfer = document.querySelector('.form__btn--transfer');
const btnLoan = document.querySelector('.form__btn--loan');
const btnClose = document.querySelector('.form__btn--close');
const btnSort = document.querySelector('.btn--sort');

const inputLoginUsername = document.querySelector('.login__input--user');
const inputLoginPin = document.querySelector('.login__input--pin');
const inputTransferTo = document.querySelector('.form__input--to');
const inputTransferAmount = document.querySelector('.form__input--amount');
const inputLoanAmount = document.querySelector('.form__input--loan-amount');
const inputCloseUsername = document.querySelector('.form__input--user');
const inputClosePin = document.querySelector('.form__input--pin');

/////////////////////////////////////////////////
//Start()
// DispTransact(accounts[CurAcc].movements);
CreateUserName(accounts);
// BalanceCal(accounts[CurAcc].movements);
// CallInOut(accounts[CurAcc].movements);
//FUNTIONS
function addAccountName() {
  document.querySelectorAll('.options').forEach(e => e.remove());
  accounts.forEach(function (acc) {
    if (CurAcc.owner === acc.owner) return;
    inputTransferTo.insertAdjacentHTML(
      'afterbegin',
      `<option class ="options" value="${acc.username}">${acc.owner}</option>`
    );
  });
}
function Reset() {
  inputClosePin.value =
    inputCloseUsername.value =
    inputLoanAmount.value =
    inputLoginPin.value =
    inputLoginUsername.value =
    inputTransferAmount.value =
    inputTransferTo.value =
      '';
  inputClosePin.blur();
  inputCloseUsername.blur();
  inputLoanAmount.blur();
  inputLoginPin.blur();
  inputLoginUsername.blur();
  inputTransferAmount.blur();
  inputTransferTo.blur();
}
function ResetUI() {
  DispTransact(CurAcc);
  BalanceCal(CurAcc.movements);
  CallInOut(CurAcc);
}
function DateDiff(date1, date2) {
  return Math.round(Math.abs(date1 - date2) / (1000 * 60 * 60 * 24));
}
function DispDate(date) {
  const duration = DateDiff(new Date(), date);
  const [dateTra, monthTra, yearTra] = [
    `${date.getDate()}`.padStart(2, 0),
    `${date.getMonth() + 1}`.padStart(2, 0),
    date.getFullYear(),
  ];
  if (duration === 0) return 'Today';
  else if (duration === 1) return 'Yesterday';
  else if (duration <= 7) return `${duration} days ago`;
  else return Intl.DateTimeFormat(CurAcc.locale).format(date);
  // else return `${dateTra}/${monthTra}/${yearTra}`;
}

function DispTransact(acc, sort = false) {
  let movs = acc.movements;
  const now = new Date();
  const dayFormat = {
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    month: 'numeric',
    year: 'numeric',
  };
  labelDate.textContent = Intl.DateTimeFormat(CurAcc.locale, dayFormat).format(
    now
  );
  // const [date, month, year, hour, min] = [
  //   `${now.getDate()}`.padStart(2, 0),
  //   `${now.getMonth() + 1}`.padStart(2, 0),
  //   now.getFullYear(),
  //   `${now.getHours()}`.padStart(2, 0),
  //   `${now.getMinutes()}`.padStart(2, 0),
  // ];

  // labelDate.textContent = `${date}/${month}/${year},${hour}:${min}`;
  if (sort) {
    movs = movs.slice().sort(function (a, b) {
      return a - b;
    });
  }
  containerMovements.innerHTML = '';
  movs.forEach(function (mov, i) {
    let mode;
    const dateTrans = new Date(acc.movementsDates[i]);
    const Dispdate = DispDate(dateTrans);
    if (mov > 0) mode = 'deposit';
    else mode = 'withdrawal';
    mov = Math.abs(mov);
    const formatCur = new Intl.NumberFormat(CurAcc.locale, {
      style: 'currency',
      currency: CurAcc.currency,
    }).format(mov);

    const movment = ` 
    <div class="movements__row">
      <div class="movements__type movements__type--${mode}">
      ${i + 1} ${mode}
       </div>
      <div class="movements__date">${Dispdate}</div>
      <div class="movements__value">${formatCur}</div>
    </div>`;

    containerMovements.insertAdjacentHTML('afterbegin', movment);
  });
}
function CreateUserName(accounts) {
  for (const account of accounts) {
    account.username = account.owner
      .toLowerCase()
      .split(' ')
      .map(function (a) {
        return a[0];
      })
      .join('');

    // account.UserName = "";
    // words.forEach(function (word) {
    //   account.UserName += word[0];
    // });
  }
}
function BalanceCal(Mov) {
  const balance = Mov.reduce(function (acc, mov) {
    return acc + mov;
  }, 0);
  CurAcc.balance = balance;
  const formatCur = new Intl.NumberFormat(CurAcc.locale, {
    style: 'currency',
    currency: CurAcc.currency,
  }).format(balance);

  labelBalance.textContent = formatCur;
}
function CallInOut(Acc) {
  const In = Acc.movements
    .filter(function (a) {
      return a > 0;
    })
    .reduce(function (total, cur) {
      return total + cur;
    }, 0);
  const Out = Acc.movements
    .filter(function (a) {
      return a < 0;
    })
    .reduce(function (total, cur) {
      return total + cur;
    }, 0);
  const int = Acc.movements
    .filter(function (a) {
      return a > 0;
    })
    .map(function (interest) {
      return (interest * Acc.interestRate) / 100;
    })
    .filter(function (Int) {
      return Int >= 1;
    })
    .reduce(function (Int, cur) {
      return Int + cur;
    }, 0);
  const formatCur = new Intl.NumberFormat(CurAcc.locale, {
    style: 'currency',
    currency: CurAcc.currency,
  });

  labelSumInterest.textContent = formatCur.format(int);
  labelSumIn.textContent = formatCur.format(In);
  labelSumOut.textContent = formatCur.format(Out);
}
function Login() {
  CurAcc = accounts.find(function (acc) {
    return inputLoginUsername.value === acc.username;
  });
  if (Number(inputLoginPin.value) === CurAcc.pin) {
    containerApp.style.opacity = 100;
    labelWelcome.textContent = `Welcome back ,${CurAcc.owner.split(' ')[0]}`;
  }
  if (timerFun) clearInterval(timerFun);
  timerFun = StartTmeOut();

  Reset();
  ResetUI();
  addAccountName();
}
function transaction() {
  if (timerFun) clearInterval(timerFun);
  timerFun = StartTmeOut();
  const To = accounts.find(function (dest) {
    return inputTransferTo.value === dest.username;
  });

  const Amount = Number(inputTransferAmount.value);

  if (
    CurAcc.balance >= Amount &&
    Amount > 0 &&
    CurAcc.username !== To?.username &&
    To
  ) {
    CurAcc.movements.push(-Amount);
    To.movements.push(Amount);
    CurAcc.movementsDates.push(new Date());
    To.movementsDates.push(new Date());
  } else console.log('INVALID');

  ResetUI();
  Reset();
}
function CloseAcc() {
  if (
    Number(inputClosePin.value) === CurAcc.pin &&
    inputCloseUsername.value === CurAcc.username
  ) {
    const index = accounts.findIndex(function (a) {
      return inputCloseUsername.value === a.username;
    });
    accounts.splice(index, 1);
    containerApp.style.opacity = 0;
  }
}
function Loan() {
  if (timerFun) clearInterval(timerFun);
  timerFun = StartTmeOut();
  const LoanAmmount = Math.floor(inputLoanAmount.value);
  if (
    LoanAmmount &&
    LoanAmmount > 0 &&
    CurAcc.movements.some(function (a) {
      return a >= 0.1 * LoanAmmount;
    })
  ) {
    Reset();
    setTimeout(function () {
      CurAcc.movements.push(LoanAmmount);
      CurAcc.movementsDates.push(new Date());

      ResetUI();
    }, 3000);
  }
}
function StartTmeOut() {
  let time = 100;
  const tick = function () {
    let min = String(Math.trunc(time / 60)).padStart(2, 0);
    let sec = String(time % 60).padStart(2, 0);
    labelTimer.textContent = `${min}:${sec}`;
    if (time === 0) {
      containerApp.style.opacity = 0;
    }
    time--;
  };
  tick();
  const Timer = setInterval(tick, 1000);

  return Timer;
}
function ResetTimer() {}
//EVENT HANDLERS
btnLogin.addEventListener('click', function (e) {
  e.preventDefault();
  Login();
});
btnTransfer.addEventListener('click', function (e) {
  e.preventDefault();
  transaction();
});
btnClose.addEventListener('click', function (e) {
  e.preventDefault();
  CloseAcc();
});
btnLoan.addEventListener('click', function (e) {
  e.preventDefault();
  Loan();
});
let Sorted = false;
btnSort.addEventListener('click', function (e) {
  e.preventDefault();
  Sorted = Sorted ? false : true;
  DispTransact(CurAcc, Sorted);
});
